import { Button, Table, Modal, Form, InputNumber, DatePicker, Space, Popconfirm, Tooltip } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { useState } from 'react';
import {
  asyncReqUserMeasures,
  reqAddMeasure,
  reqDeleteMeasureRecord,
  reqUserMeasures,
  setUserMeasures,
  updateMeasureRecord,
  reqChangeMeasureRecord } from './store/usermeasures'
import { timeMomentToTimestamp, timestampToLocalDatestring } from './store/utils';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import moment from 'moment';


function NewRecordBlock({ metric }) {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isModalUpdating, setIsModalUpdating] = useState(false)
  const [form] = Form.useForm();
  const dispatch = useDispatch()

  const showNewRecordForm = () => {
    setIsModalUpdating(false)
    setIsModalVisible(true)
  }
  const handleFormOk = () => {
    setIsModalUpdating(true)

    const timestamp = timeMomentToTimestamp(form.getFieldValue('date'))
    reqAddMeasure(metric, timestamp, form.getFieldValue('value'))
      .then(json => {
        reqUserMeasures(metric)
          .then(payload => {
            dispatch(setUserMeasures(payload))
            setIsModalVisible(false)
            setIsModalUpdating(false)
          })
      })
  }

  const handleFormCancel = () => {
    setIsModalVisible(false)
  }

  const disabledDate = (current) => {
    // Can not select days in future
    return current && current > moment().endOf('day');
  };

  return (
    <div>
      <Button className="underlying-block" onClick={showNewRecordForm}>Добавить запись</Button>

      <Modal
        title="Добавить запись"
        visible={isModalVisible}
        confirmLoading={isModalUpdating}
        onOk={handleFormOk}
        onCancel={handleFormCancel}>
        <Form
          form={form}
          labelCol={{span: 8}} wrapperCol={{span: 16}}
          initialValues={{
            date: moment(moment.now())
          }}
          >
          <Form.Item label="Дата замера" name="date">
            <DatePicker placeholder="Дата" format='DD.MM.YYYY' disabledDate={disabledDate}/>
          </Form.Item>
          <Form.Item label="Новое значение" name="value">
            <InputNumber
              placeholder="Новое значение"
              min={1} max={1000}
              step={metric === 'ftp' ? "1" : "0.1"}
              addonAfter={metric === 'ftp' ? "Вт" : "Кг"}
              />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

function MeasuresTable({ metric }) {
  const dispatch = useDispatch()
  const needToRequest = useSelector(state => state.usermeasures.needToRequest[metric])
  const isLoading = useSelector(state => state.usermeasures.isLoading[metric])
  const records = useSelector(state => state.usermeasures.records[metric])

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState({});

  if (needToRequest) {
    dispatch(asyncReqUserMeasures(metric))
  }

  const handleDeleteRecord = (recordId) => {
    reqDeleteMeasureRecord(metric, recordId)

    const payload = {
      metric:metric,
      records:records.filter((item) => item.id !== recordId)
    }
    dispatch(setUserMeasures(payload))
  }

  const showChangeValueForm = (record) => {
    const data = {
      id: record.id,
      date: record.date,
      value: record.value
    }

    setModalData(data)
    setIsModalVisible(true)
  }

  const handleModalFormOk = () => {
    reqChangeMeasureRecord(metric, modalData.id, modalData.date, modalData.value)

    const payload = {...modalData, metric:metric}

    dispatch(updateMeasureRecord(payload))
    
    setIsModalVisible(false);
  }

  const handleModalFormCancel = () => {
    setIsModalVisible(false);
  }

  const handleModalInputChange = (inputValue) => {
    const newData = {...modalData, value:inputValue}
    setModalData(newData)
  }

  return (
    <div>
      <Modal title="Изменить значение" visible={isModalVisible} onOk={handleModalFormOk} onCancel={handleModalFormCancel}>
        <InputNumber
          placeholder="Новое значение"
          min={1} max={1000}
          step={metric === 'ftp' ? "1" : "0.1"}
          addonAfter={metric === 'ftp' ? "Вт" : "Кг"}
          onChange={handleModalInputChange}
          defaultValue={modalData.value}
          value={modalData.value} />
      </Modal>
      <Table
        size='small'
        loading={needToRequest || isLoading}
        rowKey='id'
        dataSource={records}
        pagination={false}>
        <Table.Column title="Дата" dataIndex="date" render={
          (_, record) => { return timestampToLocalDatestring(record.date) }
        } />
        <Table.Column title="Значение" dataIndex="value" />
        <Table.Column title="Действие" key="action" render = {
          (_, record) => {
            return (
            <Space size="middle">
              <Popconfirm title="Точно удалить?" okText="Да" cancelText="Нет" onConfirm={() => handleDeleteRecord(record.id)}>
                <Button size="small" type="dashed" shape="circle" icon={<DeleteOutlined />} />
              </Popconfirm>
              <Tooltip title="Изменить значение">
              <Button size="small" type="dashed" shape="circle" icon={<EditOutlined />} onClick={() => showChangeValueForm(record)} />
            </Tooltip>
            </Space>)
          }
        }/>
      </Table>
      {!needToRequest && !isLoading && ( <NewRecordBlock metric={metric}/> )}
    </div>
  )
}

export function SettingsFTP() {
    return (<MeasuresTable metric='ftp' />)
}

export function SettingsWeight() {
  return (<MeasuresTable metric='weight' />)
}
